import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=26fc1958&"
import script from "./MainContent.vue?vue&type=script&lang=ts&"
export * from "./MainContent.vue?vue&type=script&lang=ts&"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=26fc1958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports